<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}资产退货</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">退库基础信息</span>
          </div>
          <el-row>
            <el-col :span="6">
              <el-form-item label="退货单号" prop="no">
                <el-input disabled v-model="form.no" placeholder="系统自动生成退货单号" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建人" prop="createdUserName">
                <el-input v-model="form.createdUserName" disabled style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建时间" prop="createdTime">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width: 90%">
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="关联入库单" prop="assetInStockNo">
                <el-select :disabled="!editMode" v-model="form.assetInStockNo" style="width: 90%" filterable placeholder="请选择关联入库单" :filter-method="getAssetInStocks" @change="assetInStockChange">
                  <el-option v-for="item in STATIC_AssetInStocks" :key="item.id" :label="item.no" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="供应商" prop="supplierName">
                <el-input disabled v-model="form.supplierName" placeholder="系统自动带出供应商" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="退货库房" prop="warehouseName">
                <!-- <el-select :disabled="!editMode" v-model="form.warehouseName" style="width: 90%" filterable placeholder="请选择入库库房" :filter-method="getWarehouses" @change="warehouseChange">
                  <el-option v-for="item in STATIC_Warehouses" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select> -->
                <el-input disabled v-model="form.warehouseName" placeholder="系统自动带出退货库房" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="库管员" prop="warehouseManagerName">
                <el-input disabled v-model="form.warehouseManagerName" placeholder="系统自动带出库管员" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="退货日期" prop="date">
                <el-date-picker :disabled="!editMode" v-model="form.date" style="width: 90%" type="date" value-format="yyyy-MM-dd" placeholder="请选择入库日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <!-- </el-row>

          <el-row> -->
            <el-col :span="6">
              <el-form-item label="总数量" prop="totalNumber">
                <el-input disabled v-model="form.totalNumber" placeholder="系统自动带出总数量" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="总金额" prop="totalAmount">
                <el-input disabled v-model="form.totalAmount" placeholder="系统自动带出总金额" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="billNo">
                <label slot="label">
                  <span>发票号</span>
                  <span style="margin-left: 10px; font-size: 10px; color: #606166">多个发票号请用逗号隔开</span>
                </label>
                <el-input disabled v-model="form.billNo" placeholder="请填写发票号" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="发票金额" prop="billAmount">
                <el-input disabled v-model="form.billAmount" placeholder="请填写发票金额" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input :disabled="!editMode" v-model="form.remark" placeholder="请填写备注" resize="none" type="textarea" :rows="5" style="width: 95%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">退货详细信息</span>
          </div>

          <div v-if="editMode" style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button class="btn" size="small" :disabled="childMultiple" type="danger" v-preventReClick @click="handleDeleteChildForm">删除</el-button>
          </div>
          <div v-else style="margin-top: 20px"></div>

          <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px" @cell-dblclick="cellDblclick" @selection-change="handleChildSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column show-overflow-tooltip type="selection" fixed width="50" align="center" />
            <el-table-column show-overflow-tooltip label="资产编码" align="center" width="140" prop="fixedAssetNo" />
            <el-table-column show-overflow-tooltip label="资产名称" align="center" width="130" prop="fixedAssetName" />
            <el-table-column show-overflow-tooltip label="规格型号" align="center" width="130" prop="specName" />
            <el-table-column show-overflow-tooltip label="单位" align="center" width="80" prop="unitName" />
            <!-- <el-table-column show-overflow-tooltip label="品牌" align="center" width="100" prop="brandName" /> -->
            <el-table-column show-overflow-tooltip label="单价" align="center" width="80" prop="price" />
            <el-table-column show-overflow-tooltip label="退货数量" align="center" width="80" prop="number" />
            <el-table-column show-overflow-tooltip label="退货金额" align="center" width="100" prop="amount" />
            <el-table-column show-overflow-tooltip label="资产类型" align="center" width="130" prop="assetTypeName" />
            <el-table-column show-overflow-tooltip label="生产厂家" align="center" width="130" prop="manufacturerName" />
            <el-table-column show-overflow-tooltip label="注册证号" align="center" width="120" prop="certNo" />
            <el-table-column show-overflow-tooltip label="财务分类" align="center" width="130" prop="financeTypeName" />
            <el-table-column show-overflow-tooltip label="产地类型" align="center" width="80" prop="productionPlaceName" />
            <!-- <el-table-column show-overflow-tooltip label="产品来源" align="center" width="130" prop="purchaseMode" /> -->
            <el-table-column show-overflow-tooltip label="货位" align="center" width="130" prop="locationName" />

            <!-- <el-table-column show-overflow-tooltip label="是否房屋建筑" align="center" width="130" prop="isBuilding" />
            <el-table-column show-overflow-tooltip label="配件" align="center" width="130" prop="parts" />
            <el-table-column show-overflow-tooltip label="面积" align="center" width="130" prop="area" /> -->

            <el-table-column show-overflow-tooltip label="包装说明" align="center" width="120" prop="packDesc" />
            <el-table-column show-overflow-tooltip label="退货原因" align="center" width="120" prop="remark" />
          </el-table>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>

      <el-dialog title="资产信息" :visible.sync="openSubformModal" :center="true" width="1100px" :before-close="cancelChildDialog" :close-on-click-modal="false">
        <el-form label-position="top" label-width="80px" ref="childForm" :model="childForm" :rules="childFormRules">
          <el-row>
            <el-col :span="6">
              <el-form-item label="资产编码" prop="fixedAssetNo">
                <SelectTable :disabled="!editMode" :columns="inStockColumns" :placeholder="'请选择资产编码'" :innerName="childForm.fixedAssetNo" :dataList="assetList" @filterMethod="getFixedAssetList" @change="selectAsset" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="资产名称" prop="name">
                <el-input disabled v-model="childForm.fixedAssetName" placeholder="系统自动带出资产名称" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="规格型号" prop="specName">
                <el-input disabled v-model="childForm.specName" placeholder="系统自动带出规格型号" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="单位" prop="unitName">
                <el-input disabled v-model="childForm.unitName" placeholder="系统自动带出单位" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="品牌" prop="brandName">
                <el-input disabled v-model="childForm.brandName" placeholder="系统自动带出品牌" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="单价" prop="price">
                <el-input disabled v-model="childForm.price" placeholder="请填写单价" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="退货数量" prop="number">
                <el-input-number :disabled="!editMode" v-model="childForm.number" :min="0" :precision="2" :controls="false" placeholder="请填写退货数量" @change="childNumberChange" style="width: 100%"></el-input-number>
                <!-- <el-input :disabled="!editMode" v-model="childForm.number" placeholder="请填写退货数量" @change="childNumberChange" /> -->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="退货金额" prop="amount">
                <el-input disabled v-model="childForm.amount" placeholder="系统自动带出退货金额" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="资产类型" prop="assetTypeName">
                <el-input disabled v-model="childForm.assetTypeName" placeholder="系统自动带出资产类型" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="注册证" prop="certNo">
                <el-input disabled v-model="childForm.certNo" placeholder="系统自动带出注册证" />
                <!-- <el-select :disabled="!editMode" v-model="childForm.certNo" style="width: 90%" filterable placeholder="请选择注册证" :filter-method="getProductRegistCerts" @change="certChange">
                  <el-option v-for="item in STATIC_ProductRegistCerts" :key="item.id" :label="item.no" :value="item.id">
                  </el-option>
                </el-select> -->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="生产厂家" prop="manufacturerName">
                <el-input disabled v-model="childForm.manufacturerName" placeholder="系统自动带出生产厂家" />
                <!-- <el-select :disabled="!editMode" v-model="childForm.manufacturerName" style="width: 90%" filterable placeholder="请选择生产厂家" :filter-method="getManufacturers" @change="manufacturerChange">
                  <el-option v-for="item in STATIC_Manufacturers" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select> -->
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="合同编号" prop="contractNo">
                <el-input disabled v-model="childForm.contractNo" placeholder="系统自动带出合同编号" />
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item label="财务分类" prop="financeTypeName">
                <el-input disabled v-model="childForm.financeTypeName" placeholder="系统自动带出财务分类" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="产地类型" prop="productionPlaceName">
                <el-input disabled v-model="childForm.productionPlaceName" placeholder="系统自动带出产地类型" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品来源" prop="assetSourceName">
                <!-- <el-select :disabled="!editMode" v-model="childForm.purchaseMode" placeholder="请选择产品来源" style="width: 90%;">
                  <el-option v-for="item in PurchaseModeOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select> -->
                <!-- <el-input disabled v-model="childForm.assetSourceName" placeholder="系统自动带出产品来源" /> -->
                <el-select disabled v-model="childForm.assetSourceName" style="width: 100%" placeholder="系统自动带出产品来源" @change="assetSourceChange">
                  <el-option v-for="item in STATIC_ProductRegistCerts" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="货位" prop="locationId">
                <!-- <el-select :disabled="!editMode" v-model="childForm.locationId" placeholder="请选择货位" style="width: 100%;" @change="locationChange">
                  <el-option v-for="item in STATIC_Locations" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select> -->
                <el-input disabled v-model="childForm.locationName" placeholder="系统自动带出货位" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="是否房屋建筑" prop="isBuilding">
                <el-select disabled v-model="childForm.isBuilding" placeholder="请选择状态" style="width: 100%">
                  <el-option v-for="item in WhetherOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item v-if="childForm.isBuilding != 1" label="配件" prop="parts">
                <el-input disabled v-model="childForm.parts" placeholder="请填写配件" style="width: 100%"></el-input>
              </el-form-item>
              <el-form-item v-else label="面积（㎡）" prop="area">
                <el-input disabled v-model="childForm.area" placeholder="请填写面积" style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="包装说明" prop="packDesc">
                <el-input disabled v-model="childForm.packDesc" placeholder="请填写包装说明" resize="none" type="textarea" :rows="5"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="退货原因" prop="remark">
                <el-input :disabled="!editMode" v-model="childForm.remark" placeholder="请填写退货原因" resize="none" type="textarea" :rows="5"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- <el-row>
            <el-col :span="12">
              <el-form-item label="资产启用状态">
                <el-switch :disabled="!editMode" v-model="childForm.state" active-color="#286AB4" inactive-color="#D4D4D4" :active-value="1" :inactive-value="0">
                </el-switch>
                <span v-if="form.state">启用</span>
                <span v-else>禁用</span>
              </el-form-item>
            </el-col>
          </el-row> -->
        </el-form>
        <div slot="footer" class="dialog-footer" style="">
          <el-button v-if="editMode" class="btn primary" type="primary" size="small" v-preventReClick @click="continueAdd">新增下一条</el-button>
          <el-button class="btn" size="small" v-preventReClick @click="cancelChildDialog">取 消</el-button>
          <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submitChildForm">确 定</el-button>
        </div>
      </el-dialog>

      <!-- <el-image-viewer :openViewer="openViewer" :fileId="fileId" :fileName="fileName" @closeImageViewer="closeImageViewer" /> -->
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="$router.go(-1)">返 回</el-button>
    </div>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import {
  GetAssetOutStockById,
  GetAssetInStockById,
  SaveAssetOutStock,
  RejectAssetOutStock,
} from "@/api";
import { WhetherOptions } from "@/enum";
// import Address from '@/components/address';
// import ElImageViewer from '@/components/elImageViewer'
import SelectTable from "@/components/select-table";
import SeparateInput from "@/components/separate-input";
import ApproveInfo from "@/components/approve-info";
import { Arabia_To_SimplifiedChinese } from "@/utils/number.js";

export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin],
  components: {
    SelectTable,
    ApproveInfo,
    SeparateInput,
    // ElImageViewer
  },
  data () {
    return {
      form: {},
      WhetherOptions: WhetherOptions,
      Arabia_To_SimplifiedChinese: Arabia_To_SimplifiedChinese,
      rules: {
        assetCheckNo: [
          { required: true, message: "验收单不能为空", trigger: "blur" },
        ],
        warehouseName: [
          { required: true, message: "退货库房不能为空", trigger: "blur" },
        ],
        date: [
          { required: true, message: "退货日期不能为空", trigger: "blur" },
        ],
      },
      childFormRules: {
        fixedAssetNo: [
          { required: true, message: "资产编码不能为空", trigger: "blur" },
        ],
        number: [
          { required: true, message: "数量不能为空", trigger: "blur" },
          // { required: true, validator: this.validateNumber, tigger: 'blur' }
        ],
        // price: [
        //   { required: true, message: "单价不能为空", trigger: "blur" }
        // ],
        // manufacturerName: [
        //   { required: true, message: "生产厂家不能为空", trigger: "blur" }
        // ],
        remark: [
          { required: true, message: "退货原因不能为空", trigger: "blur" },
        ],
      },
      editMode: false,
      showWorkFlowInfo: false,
      assetList: [],
      reject: RejectAssetOutStock,
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      openSubformModal: false,
      childForm: {},
    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();

      if (query.inStockId) {
        this.assetInStockChange(query.inStockId);
      }
    }

    // if (query.editMode == 1) {
    //   this.editMode = true
    // }

    this.getWarehouses("");
    this.getAssetChecks("");
    this.getAssetInStocks("");
    this.getProductRegistCerts();
  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      GetAssetOutStockById({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        this.getLocations(this.form.warehouseId);
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        this.getFixedAssetList("");

        this.initWorkFlowProperty(this.form);
      });
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        SaveAssetOutStock(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          this.$router.push({ path: this.getMainPath(this.$route.path) });
        }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
      });
    },
    resetForm () {
      this.form = {
        inStockType: 0,
        supplierId: "",
        supplierName: "",
        warehouseId: "",
        warehouseName: "",
        state: 0,
        details: [],
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        orgCode :sessionStorage.getItem('orgId')
      };
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      this.$router.push({ path: this.getMainPath(this.$route.path) });
    },

    // 明细表
    handleAddChildForm () {
      this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();
    },
    handleDeleteChildForm () {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });
      this.autoTotalAmount();
    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    cellDblclick (row, column, cell, event) {
      // 打开子表弹窗
      this.openSubformModal = true;
      this.editChildren = true;
      this.resetDetailFormData();
      this.childForm = JSON.parse(JSON.stringify(row));
      this.childForm.details.forEach((e, index) => {
        e.$index = index + 1;
      });
    },

    resetDetailFormData () {
      this.childForm = {
        $index: this.form.details.length + 1,
        fixedAssetNo: "",
        name: "",
        number: 0,
        price: 0,
        amount: 0,
        remark: "",
        state: 1,
        locationId: "",
        locationName: "",
        certId: "",
        certNo: "",
        manufacturerId: "",
        manufacturerName: "",
        brandId: "",
        brandName: "",
        details: [],
      };
    },
    cancelChildDialog () {
      this.openSubformModal = false;
    },
    submitChildForm () {
      this.pushChildForm(true);
    },
    continueAdd () {
      this.editChildren = false;
      this.pushChildForm();
    },
    pushChildForm (close) {
      this.$refs["childForm"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.childForm.orgCode = sessionStorage.getItem('orgId')
        // this.capitalSourceChange()
        let item = this.form.details.find(
          (e) =>
            e.assetId == this.childForm.assetId &&
            e.price == this.childForm.price &&
            e.locationName == this.childForm.locationName &&
            e.assetSource == this.childForm.assetSource &&
            e.packDesc == this.childForm.packDesc &&
            e.manufacturerId == this.childForm.manufacturerId &&
            e.certId == this.childForm.certId &&
            e.brandId == this.childForm.brandId
        );
        if (item && !this.editChildren) {
          // 新增有重复项提示
          // Object.assign(item, this.childForm);
          this.$my_message(`当前退货信息已存在，请去子表编辑！`, "error");
          return;
        } else if (item && this.editChildren) {
          // 编辑
          Object.assign(item, this.childForm);
        } else {
          this.form.details.push(this.childForm);
        }

        this.autoTotalAmount();
        this.resetDetailFormData();
        if (close) {
          this.openSubformModal = false;
        }
      });
    },
    childNumberChange () {
      this.childForm.unBillNumber = this.childForm.number;
      this.autoAmount();
    },
    autoAmount () {
      this.childForm.amount =
        (this.childForm.number * this.childForm.price).toFixed(2) * 1;
      this.childForm.unBillAmount = this.childForm.amount;
    },
    autoTotalAmount () {
      let totalNumber = 0;
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        totalNumber = totalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      this.form.totalNumber = totalNumber;
      this.form.totalAmount = totalAmount;
      this.form.unBillNumber = totalNumber;
      this.form.unBillAmount = totalAmount;
    },

    // change event
    assetInStockChange (val) {
      GetAssetInStockById({ id: val }).then((res) => {
        this.form.assetInStockId = val;
        this.form.assetInStockNo = res.returnData.no;
        this.form.supplierId = res.returnData.supplierId;
        this.form.supplierName = res.returnData.supplierName;
        this.form.warehouseId = res.returnData.warehouseId;
        this.form.warehouseName = res.returnData.warehouseName;
        this.form.warehouseId = res.returnData.warehouseId;
        this.form.warehouseName = res.returnData.warehouseName;
        this.form.warehouseManagerId = res.returnData.warehouseManagerId;
        this.form.warehouseManagerName = res.returnData.warehouseManagerName;

        this.assetList = res.returnData.details.filter(
          (item) => item.number > item.returnNumber
        );
        this.form.details = [];
        if (this.assetList) {
          this.assetList.map((item) => {
            item.number = item.number - item.returnNumber;
            item.amount = item.number * item.price;

            return item;
          });
          var query = this.$route.query;
          if (query.inStockId) {
            this.form.details = this.assetList;

            this.autoTotalAmount();
          }
        }
      });
    },
    selectAsset (row) {
      this.childForm = Object.assign(this.childForm, row, {
        // fixedAssetNo: row.no,
        // fixedAssetName: row.name,
        // assetId: row.id,
        remark: "",
        id: 0,
        stockState: row.state,
      });
    },

    getFixedAssetList (keyWord) {
      GetAssetInStockById({ id: this.form.assetInStockId }).then((res) => {
        this.assetList = res.returnData.details;
      });
    },

    // // 其他
    // validateNumber (rule, value, callback) {
    //   if (value > this.childForm.notCheckedNumber) {
    //     callback(new Error(`验收数量不能大于未验收数量(${this.childForm.notCheckedNumber})`))
    //   }
    //   else {
    //     callback()
    //   }
    // }
    assetSourceChange (val) {
      this.childForm.assetSource = val
    }
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}
/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>
